// @debt quality "Kamile: project role constants duplicated in models/project_role.py"
export const ROLES = {
  USER: "USER",
  CONSTRUCTION_GENERALIST: "CONSTRUCTION_GENERALIST",
  EQUIPMENT_SPECIALIST: "EQUIPMENT_SPECIALIST",
  ELECTRICITY_SPECIALIST: "ELECTRICITY_SPECIALIST",
  ELECTRICITY_ELEVATOR_SPECIALIST: "ELECTRICITY_ELEVATOR_SPECIALIST",
  FLUID_ENERGY_SPECIALIST: "FLUID_ENERGY_SPECIALIST",
  ACOUSTIC_SPECIALIST: "ACOUSTIC_SPECIALIST",
  ACCESSIBILITY_SPECIALIST: "ACCESSIBILITY_SPECIALIST",
  TECHNICAL_DIRECTION_EXPERT: "TECHNICAL_DIRECTION_EXPERT",
  // INFO - HM - 09/04/2026 - ITM-specific internal contributor roles (RTEC-2369)
  GENERAL_SECURITY_SPECIALIST: "GENERAL_SECURITY_SPECIALIST",
  FIRE_DETECTION_SPECIALIST: "FIRE_DETECTION_SPECIALIST",
  SMOKE_EXTRACTION_SPECIALIST: "SMOKE_EXTRACTION_SPECIALIST",
  HVAC_SPECIALIST: "HVAC_SPECIALIST",
  AUTOMATIC_EXTINCTION_SPECIALIST: "AUTOMATIC_EXTINCTION_SPECIALIST",
  CO_VENTILATION_DETECTION_SPECIALIST: "CO_VENTILATION_DETECTION_SPECIALIST",
  REFRIGERATION_SPECIALIST: "REFRIGERATION_SPECIALIST",
  GAS_DETECTION_SPECIALIST: "GAS_DETECTION_SPECIALIST",
  ENVIRONMENT_SPECIALIST: "ENVIRONMENT_SPECIALIST",
  DANGEROUS_FLUIDS_TANKS_SPECIALIST: "DANGEROUS_FLUIDS_TANKS_SPECIALIST",
  EXTERNAL: "EXTERNAL",
  EXTERNAL_NO_ACCESS: "EXTERNAL_NO_ACCESS",
  DEVELOPER: "DEVELOPER",
  PROJECT_MANAGER: "PROJECT_MANAGER",
};

export const SOCOTEC_GROUPS = {
  SOCOTEC_USER: "SocotecUser",
  AGENCY_MANAGER: "AgencyManager",
  AGENCY_GROUP_MANAGER: "AgencyGroupManager",
  NATIONAL_MANAGER: "NationalManager",
  ACTIVITY_DIRECTOR: "ActivityDirector",
  AG_KEY_USER: "AGKeyUser",
  KEY_USER: "KeyUser",
  EXTERNAL_USER: "ExternalUser",
  DEVELOPER: "Developer",
  SUPER_USER: "SuperUser",
  TECHNICAL_DIRECTION: "TechnicalDirection",
};

export const SOCOTEC_EMPLOYEE_GROUPS = [
  SOCOTEC_GROUPS.SOCOTEC_USER,
  SOCOTEC_GROUPS.AGENCY_MANAGER,
  SOCOTEC_GROUPS.AGENCY_GROUP_MANAGER,
  SOCOTEC_GROUPS.NATIONAL_MANAGER,
  SOCOTEC_GROUPS.AG_KEY_USER,
  SOCOTEC_GROUPS.ACTIVITY_DIRECTOR,
  SOCOTEC_GROUPS.TECHNICAL_DIRECTION,
  SOCOTEC_GROUPS.KEY_USER,
];
export const MANAGER_GROUPS = [
  SOCOTEC_GROUPS.AGENCY_MANAGER,
  SOCOTEC_GROUPS.AGENCY_GROUP_MANAGER,
  SOCOTEC_GROUPS.NATIONAL_MANAGER,
];
export const EXTRA_MANAGER_GROUPS = [
  SOCOTEC_GROUPS.AG_KEY_USER,
  SOCOTEC_GROUPS.ACTIVITY_DIRECTOR,
  SOCOTEC_GROUPS.KEY_USER,
  SOCOTEC_GROUPS.TECHNICAL_DIRECTION,
];
export const NO_ACCESS_GROUPS = [SOCOTEC_GROUPS.EXTERNAL_USER];

export const GROUPS = {
  CT: "CT",
  SPS: "SPS",
  DIAG: "DIAG",
  APB: "APB",
};
